module.exports = __webpack_public_path__ + "71d0e4502314ad5c38b4cbc002ad1e68.png";